/**
 * Created by MK on 3/16/2016.
 */
import {sendEvent} from "@/utils/GEvents";

const stackTraceMap = require('sourcemapped-stacktrace');


const buckets = require('buckets-js');
const _frontVersionLabel = window['_frontendVersion'] + "/" + window['_frontendBuildTag'];
let _dbgCounter = 0;

let stackTraceVerified = null;

export class _Log {
    formatTime(timeInMs) {
        return Math.round(timeInMs * 100) / 100 + "ms";
    }

    formatRpcArguments(args) {
        var res = "";
        for (var i = 0; i < args.length; i++) {
            res += this.formatSingleArg(args[i]);
            if (i != args.length - 1) {
                res += ", ";
            }
        }
        return res;
    }

    formatSingleArg(arg) {
        if (typeof arg == 'undefined') {
            return 'undefined';
        }
        if (arg === null) {
            return 'null';
        }
        if (typeof arg == 'string') {
            if (arg.length > 30) {
                arg = arg.substr(0, 27) + "...";
            }
            return "'" + arg + "'";
        }
        if (typeof arg == 'number') {
            var argS = "" + arg;
            if (argS.length > 4) {
                var parts = argS.split('.');
                if (parts.length > 1)
                    return parts[0] + "." + parts[1].substr(0, 2);
                else
                    return argS;
            }
            else
                return argS;
        }
        arg = JSON.stringify(arg);
        if (arg.length > 30) {
            arg = arg.substr(0, 27) + "...";
        }

        return arg;
    }

    async action(type, component, details){
        try{
            if(details === undefined){
                details = "";
            }
            if(component === undefined){
                component = "";
            }

            if(details.length > 128){
                details = details.substring(0, 128);
            }

            //TODO
            //await analyticsApi.frontendEvent(type, component, details);
        } catch(e){
            console.log("Error in analyticsApi.frontendEvent");
        }
    }
    constructor() {
        this.ignoreOnTest = true;
        this.logsSize = 100;
        this._loadFrontVersion();

        if(localStorage.getItem("log.level")){
            this.debugLevel = localStorage.getItem("log.level");
        } else {
            this.debugLevel = process.env.NODE_ENV == 'development' ? 0 : 0;
        }

        this.lastLog = null;
        this.logs = new buckets.Queue();
        this.errorsAndWarnings = new buckets.Queue();

        var that = this;
        if (typeof window !== 'undefined') {
            window.onerror = function (msg, url, line, col, error) {
                var extra = !col ? '' : '\ncolumn: ' + col;
                extra += !error ? '' : '\nerror: ' + (error.hasOwnProperty("stack") ? error.stack : error);

                var body = ("Error: " + msg + "\nurl: " + url + "\nline: " + line + extra);
                that.postErrorToServer("FATAL", "Unhandled exception", body);
                that.fatal(body, false);

                var suppressErrorAlert = false;
                return suppressErrorAlert;
            };
        }
    }

    // TODO
    postErrorToServer(severity, errorCode, body) {
        const SessionManager = window['SessionManager']
        if(!SessionManager || !SessionManager.isLoggedIn()){
            return;
        }

        sendEvent("error", {errorCode, _frontVersionLabel});

        if(window['Rpc'] ) {
            Rpc.Interactions.reportFrontendError(severity, errorCode, body, _frontVersionLabel).then(
                () => console.log("report send")
            ).catch(e => console.log(e));
        } else {
            console.error("Rpc not defined");
        }
    }

    //TODO special chars
    getAllAsText() {
        var txt = "";
        this.logs.forEach(function (l) {
            txt = Encoder.htmlEncode(l) + "<br/>\n" + txt;
        });
        return txt;
    }

    warning(msg, options= {details:null, css:null, notifyServer:false}){
        let l = this._formatLog("WARN", msg);

        this.lastLog = l;
        this._addToQueue(l, this.logs);
        if(options?.notifyServer){
            this.postErrorToServer("WARNING", "Log warning", msg);
        }
        this._logToConsole(msg, "WARNING", options);
    }

    info(msg, options= {details:null, css:null}) {
        let l = this._formatLog("INFO", msg);

        this.lastLog = l;
        this._addToQueue(l, this.logs);
        if (this.debugLevel < 0) {
            return;
        }
        this._logToConsole(msg, "INFO", options);
    }

    _logToConsole(msg, level, options= {details:null, css:null}) {
        if(options && options.details){
            let details = options.details;
            if(options.css){
                console.group(msg, ...options.css);
            } else{
                console.group(msg);
            }
            try {
                if (Array.isArray(details)) {
                    for (let el in details) {
                        console.log(details[el]);
                    }
                } else {
                    console.log(details);
                }
            }catch (e){

            }
            finally {
                console.groupEnd();
            }
        } else {
            if(options.css){
                console.log("["+level+"] " + msg, ...options.css);
            }else{
                console.log("["+level+"] " + msg);
            }
        }
    }

    assert(assertion, msg){
        if(assertion){
            return;
        }
        if(msg === null || msg === undefined ){
            msg = "";
        }
        if (process.env.NODE_ENV !== 'production') {
            stackTraceMap.mapStackTrace(Error().stack, (r) =>{
                let line = "undefined";
                try{
                    line = r[1].match(/\/([^\/]+\d+):\d+\)$/)[1];
                }
                finally{
                    console.log("[ASSERT FAILURE: " + line + "] " + msg);

                }
            });
        } else {
            this.fatal("ASSERTFAILURE: "  + msg, true);
        }

    }

    debugOn(){
        this.debugLevel = 2;
    }
    traceOn(){
        this.debugLevel = 3;
    }
    debugOff(){
        this.debugLevel = 0;
    }
    testOn(){
        this.traceOn();
        this.ignoreOnTest = false;
    }
    testOff(){
        this.ignoreOnTest = true;
    }

    debug(msg) {
        this._debugLog(msg, 2);
    }
    trace(msg) {
        this._debugLog(msg, 3);
    }

    async _debugLog(msg, level) {
        if(level > this.debugLevel){
            return;
        }
        if (process.env.NODE_ENV == 'test' &&  this.ignoreOnTest == true){
            return;
        }

        let levelLabel = "DGB" + level;
        if(level == 2){
            levelLabel = 'DBG';
        } else if(level == 3){
            levelLabel = 'TRACE';
        } else if(level == -1){
            levelLabel = 'WARN';
        }

        if (process.env.NODE_ENV !== 'production') {

            let num = _dbgCounter++;

            var counter = 0;
            let filter = function(l){
                return counter++ < 3;
            }

            let stack = Error().stack;

            if(process.env.NODE_ENV == 'test'){
                let ctr = 0;
                let line = ("" + stack).split("\n").find(e => e.match(/\ +at (.*)/) && (ctr++ == 2))
                line = line.match(/\ +at (.*)/)[1];
                console.log("["+ levelLabel + "-" + num + ": " + line + "] " + msg);
            }
            else {
                stackTraceMap.mapStackTrace(stack, (r) =>{
                    let line = "undefined";
                    try{
                        line = "";
                        if(r && r.length > 2){
                            let mathes = r[2].match(/\/([^\/]+\d+):\d+\)$/);
                            if(mathes){
                                line = mathes[1];
                            }
                        }
                        if(line == ""){
                            let ctr = 0;
                            line = ("" + stack).split("\n").find(e => e.match(/\ +at (.*)/) && (ctr++ == 2))
                            if(line === undefined){
                                line = '<reload-sourcemap>';
                                _dbgCounter = 0;
                            }
                            line = line.match(/\ +at (.*)/)[1];
                        }

                    }
                    finally{
                        let css = "";
                        if(level == 3){
                            css = "color: #a0a0a0"
                        } else if(level == 2){
                            css = "color: #808080"
                        }else if(level == 1){
                            css = "color: #606060"
                        }else if(level < 0){
                            css = "color: #a02020"
                        }

                        console.log("%c["+ levelLabel + "-" + num + ": " + line + "] " + msg, css);
                    }

                }, {'cacheGlobally':num != 1, 'filter': filter});
            }

        } else {
            if(level < 0){
                var l = this._formatLog("WARN", msg);
                console.log(l);
            }
        }
    }

    warn(msg, notifyServer) {
        console.error(msg);
        msg = msg?.toString?.() ?? ("" + msg);
        //this.onNewLog.fire({ type: "WARN", message: msg });
        var l = this._formatLog("WARN", msg);
        this.lastLog = l;
        this._addToQueue(l, this.logs);
        this._addToQueue(l, this.errorsAndWarnings);

        this._debugLog(msg, -2);
        if (notifyServer !== false) {
            this.postErrorToServer("WARNING", "Log warning", msg);
        }
    }

    fatal(msg, notifyServer) {
        console.error(msg);
        msg = msg?.toString?.() ?? ("" + msg);
        // this.onNewLog.fire({ type: "FATAL", message: msg });
        let l = this._formatLog("FATAL", msg);
        this.lastLog = l;
        this._addToQueue(l, this.logs);
        this._addToQueue(l, this.errorsAndWarnings);
        console.log("[FATAL] " + msg);
        if (notifyServer !== false) {
            this.postErrorToServer("FATAL", "Log fatal", msg);
        }
    }

    clearAll() {
        //this.onNewLog = new EventHost("LOG_ON_NEW_LOG");
        this.logs = new buckets.Queue();
        this.errorsAndWarnings = new buckets.Queue();
    }

    _addToQueue(msg, queue) {
        queue.enqueue(msg);
        if (queue.size() > this.logsSize) {
            queue.dequeue();
        }
    }

    _formatLog(level, msg) {
        var d = new Date();
        return "[" + level + "][" + d.toGMTString() + "]" + (msg?.toString?.() ?? ("" + msg));
    }

    _loadFrontVersion() {
    }
}

/** @type {_Log} */
const Log = new _Log();
export default Log;
if (typeof window !== 'undefined') {
    window['Log'] = Log;
}